import React from 'react';
import { StyledTab, StyledTabContainer, StyledLabel } from './tab.style';

const Tab = (props) => {
  const { buttonArray, activeTab, onButtonClick = () => {} } = props;

  return (
    <StyledTabContainer>
      {buttonArray?.map((item, index) => (
        <StyledTab
          key={index}
          isActive={item.value === activeTab}
          onClick={() => onButtonClick(item?.value)}
        >
          <StyledLabel
            cursor="pointer"
            color="normal"
            weight={item.value === activeTab ? 'bold' : 'normal'}
          >
            {item.buttonText}
          </StyledLabel>
        </StyledTab>
      ))}
    </StyledTabContainer>
  );
};

export default Tab;
